import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { newDashboardApis } from "../../sharedfiles/EndpointConfig";
// import { messageEnhancer, toaster } from "../../sharedfiles/helper";

export const NewDashboardSlice = createSlice({
    name: "NewDashboardSlice",
    initialState: {
        overallReviewReport: [],
        sportsBetReport: [],
        sportCasinoNeGameData: [],
        bonusingData: [],
        paymentData: [],
        userActivity: [],
        activeTimeData: [],
        topTenWithdrwableUsers: [],
        topWinnerLooserList: [],
        topTenSportsNeGamesCasino: [],
        prevFormData: {},
    },
    reducers: {
        setOverallReviewReport: (state, action) => {
            state.overallReviewReport = action.payload
        },
        setSportsBetReport: (state, action) => {
            state.sportsBetReport = action.payload
        },
        setSportCasinoNeGameData: (state, action) => {
            state.sportCasinoNeGameData = action.payload
        },
        setBonusingData: (state, action) => {
            state.bonusingData = action.payload
        },
        setPaymentData: (state, action) => {
            state.paymentData = action.payload
        },
        setUserActivity: (state, action) => {
            state.userActivity = action.payload
        },
        setActiveTimeData: (state, action) => {
            state.activeTimeData = action.payload
        },
        setTopTenWithdrwableUsers: (state, action) => {
            state.topTenWithdrwableUsers = action.payload
        },
        setTopWinnerLooserList: (state, action) => {
            state.topWinnerLooserList = action.payload
        },
        setTopTenSportsNeGamesCasino: (state, action) => {
            state.topTenSportsNeGamesCasino = action.payload
        },
        setPrevFormData: (state, action) => {
            state.prevFormData = action.payload;
        },
    },
})

export const {
    setOverallReviewReport,
    setSportsBetReport,
    setSportCasinoNeGameData,
    setBonusingData,
    setPaymentData,
    setUserActivity,
    setActiveTimeData,
    setTopTenWithdrwableUsers,
    setTopWinnerLooserList,
    setTopTenSportsNeGamesCasino,
    setPrevFormData
} = NewDashboardSlice.actions;

export const getOverallReviewReportByPeriod = () => (dispatch) => {
    let url = newDashboardApis.getOverallReviewReportByPeriod
    return apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setOverallReviewReport(res.data))
        }
    }).catch((error) => {
        console.error('getOverallReviewReportByPeriod error:', error)
    })
}

export const getSportsBetsReport = (param) => (dispatch) => {
    let url = newDashboardApis.getSportsBetsReport
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setSportsBetReport(res.data))
        }
    }).catch((error) => {
        console.error('getSportsBetsReport error:', error)
    })
}

export const getBetReportByGameType = (param) => (dispatch) => {
    let url = newDashboardApis.getBetReportByGameType
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setSportCasinoNeGameData(res.data))
        }
    }).catch((error) => {
        console.error('getBetReportByGameType error:', error)
    })
}

export const getBonusReport = (param) => (dispatch) => {
    let url = newDashboardApis.getBonusReport
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setBonusingData(res.data))
        }
    }).catch((error) => {
        console.error('getBonusReport error:', error)
    })
}

export const getPaymnetReport = (param) => (dispatch) => {
    let url = newDashboardApis.getPaymnetReport
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setPaymentData(res.data))
        }
    }).catch((error) => {
        console.error('getPaymnetReport error:', error)
    })
}

export const getUserActivityReport = (param) => (dispatch) => {
    let url = newDashboardApis.getUserActivityReport
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setUserActivity(res.data))
        }
    }).catch((error) => {
        console.error('getUserActivityReport error:', error)
    })
}

export const getUserActiveTimesReportByType = (param, type) => (dispatch) => {
    let url = newDashboardApis.getUserActiveTimesReportByType(type)
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setActiveTimeData(res.data))
        }
    }).catch((error) => {
        console.error('getUserActiveTimesReportByType error:', error)
    })
}

export const getTopTenWithdrawableUsers = (param) => (dispatch) => {
    let url = newDashboardApis.getTopTenWithdrawableUsers
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopTenWithdrwableUsers(res.data))
        }
    }).catch((error) => {
        console.error('getTopTenWithdrawableUsers error:', error)
    })
}

export const getTopTenWinnerLooser = (param) => (dispatch) => {
    let url = newDashboardApis.getTopTenWinnerLooser
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopWinnerLooserList(res.data))
        }
    }).catch((error) => {
        console.error('getTopTenWinnerLooser error:', error)
    })
}

export const getTopTenSportsNeGamesCasino = (param) => (dispatch) => {
    let url = newDashboardApis.getTopSportsGamesReport
    return apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setTopTenSportsNeGamesCasino(res.data))
        }
    }).catch((error) => {
        console.error('getTopTenSportsNeGamesCasino error:', error)
    })
}


export default NewDashboardSlice.reducer